/**
 * Mapping of valid alert types and their respective icons.
 */
export const types = {
  success: "check-circle",
  info: "info-circle",
  warning: "exclamation-triangle",
  danger: "exclamation-circle",
};
